/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-10 16:17:27
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

type Props = {
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;

class ProcessingUpdateBanner extends Component<ComposedProps> {
  capitalizeFirstLetter = text => {
    const { appLanguage } = this.props;
    return text.charAt(0).toLocaleUpperCase(appLanguage) + text.slice(1);
  };

  render() {
    const { syncDuration, onDismiss, featureName, i18n } = this.props;
    const positiveSyncDurationSentenceFirstSentence = this.capitalizeFirstLetter(
      i18n.translate(
        'AdminHTML.Common.ProcessingUpdateBanner.bannerContent_PositiveSyncDuration1',
        {
          t1: i18n.translate(
            `AdminHTML.Common.ProcessingUpdateBanner.bannerContent_PositiveSyncDuration1_t1_${featureName}`
          )
        }
      )
    );
    const negativeSyncDurationSentence = this.capitalizeFirstLetter(
      i18n.translate('AdminHTML.Common.ProcessingUpdateBanner.bannerContent_NegativeSyncDuration', {
        t1: i18n.translate(
          `AdminHTML.Common.ProcessingUpdateBanner.bannerContent_NegativeSyncDuration_t1_${featureName}`
        )
      })
    );
    return (
      <Banner
        title={i18n.translate('AdminHTML.Common.ProcessingUpdateBanner.bannerTitle', {
          t1: i18n.translate(
            `AdminHTML.Common.ProcessingUpdateBanner.bannerTitle_t1_${featureName}`
          )
        })}
        status="info"
        onDismiss={onDismiss}>
        {syncDuration >= 0 ? (
          <p>
            {positiveSyncDurationSentenceFirstSentence}{' '}
            {i18n.translate(
              'AdminHTML.Common.ProcessingUpdateBanner.bannerContent_PositiveSyncDuration2',
              {
                nt_duration_of_time: (
                  <strong>
                    {syncDuration > 2
                      ? i18n.translate(`AdminHTML.Common.Duration.minute`, {
                          count: syncDuration,
                          nt_number: i18n.formatNumber(syncDuration)
                        })
                      : i18n.translate('AdminHTML.Common.Duration.minute.few')}
                  </strong>
                ),
                t1: i18n.translate(
                  `AdminHTML.Common.ProcessingUpdateBanner.bannerContent_PositiveSyncDuration2_t1_${featureName}`
                )
              }
            )}
          </p>
        ) : (
          <p>{negativeSyncDurationSentence}</p>
        )}
      </Banner>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE)
});

export default connect(mapStateToProps)(withI18n()(ProcessingUpdateBanner));
